import { Directive, Input, OnChanges, SimpleChanges } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator } from '@angular/forms';
import { DateConverter, InputConverter } from 'src/app/shared/common/components/input-converter.decorator';

@Directive({
    selector: '[maxDate]',
    providers: [{ provide: NG_VALIDATORS, useExisting: MaxDateValidatorDirective, multi: true }]
})
export class MaxDateValidatorDirective implements Validator, OnChanges {
    @Input()
    @InputConverter(DateConverter)
    maxDate: Date;

    private _onValidatorChange = () => {};

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.maxDate) {
            this._onValidatorChange();
        }
    }

    registerOnValidatorChange?(fn: () => void): void {
        this._onValidatorChange = fn;
    }

    validate(control: AbstractControl): ValidationErrors {
        if (
            this.maxDate !== null &&
            this.maxDate !== undefined &&
            control.value &&
            new Date(control.value) > this.maxDate
        ) {
            return { maxDate: { maximum: this.maxDate } };
        }
        return null;
    }
}
